import React, { useEffect, useState } from "react"
import { ISelectStep, IQuery, IQueryBuilderContext, IStepValidationResponse, StepType, IDataSource } from "@types"
import { findSourceById, getSelectedStepDetailsById, handleStepFieldValueChanges, registerStep, validateFieldConfiguration, validateSource, validateStep, validateStepNameAndId } from "@utils"
import { FormSection } from "@components/FormSection/FormSection"
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput"
import { updateSource, updateStep } from "../StepConfigUtils"
import { Input } from "uxp/components"
import Icon from '@images/select.svg'
import { FieldMapper } from "../FieldMapper/FieldMapper"

export function renderStep(context: IQueryBuilderContext, query: IQuery, onChange: (query: IQuery) => void, selectedStepId: string) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId)
    const _step: ISelectStep = Object.assign({}, step as ISelectStep)

    const [errors, setErrors] = useState<Record<string, string>>({})

    useEffect(() => {
        const { isValid, errors } = validateStep(query, step as ISelectStep)
        setErrors(errors)
    }, [step])

    const source = findSourceById(query, _step?.source)

    async function onValueChange(field: string, value: any, source?: boolean) {
        const _query = await handleStepFieldValueChanges(context, query, selectedStepId, field, value, source)
        onChange(_query)
    }
    
    return <React.Fragment>
        <FormSection
            label='Source'
            error={errors?.source}
        >
            <SourceSelectorInput
                source={source}
                onChange={(newSource) => { onValueChange('source', newSource, true) }}
                availableSources={[...previousSteps, ...selectedSources]}
                query={query}
            />
        </FormSection>

        <FormSection
            label='Fields to include'
            error={errors?.include}
        >
            <FieldMapper
                fields={(_step?.include || []).map(f => ({ field: f, newField: '' }))}
                source={source as IDataSource}
                onChange={fields => onValueChange('include', fields.map(f => (f.field)))}
                disableRename={true}
            />
        </FormSection>

    </React.Fragment>
}

function validate(query: IQuery, step: ISelectStep): IStepValidationResponse {
    const errors: Record<string, string> = validateStepNameAndId(step);
    // validate source
    const source = validateSource(query, step, 'source')
    if (!source.isValid) errors.source = source.error

    if (!step?.include || step?.include?.length == 0) errors.include = 'Select atleast one field'
    else {
        const fields = validateFieldConfiguration(query, step, step?.include || [], 'source')
        if (!fields.isValid) errors.include = fields.error
    }

    return { isValid: Object.keys(errors).length === 0, errors };
}

registerStep({
    type: StepType.Select,
    name: "Select",
    description: "Select fields from the data source",
    icon: Icon,
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return { ...basicProps, source: previousSource, include: [], } as ISelectStep
    }
})